import { IEntityDataService } from "@pit/core-data";
import { IDtoUserRole } from "@pit/frontend-model";

export interface IDtoUserRoleEntityDataService extends IEntityDataService<IDtoUserRole> {

}
